<template>
  <div class="loading" v-show="isPageLoading">
    <div class="loading-content">
      <h2>Loading, please wait...</h2>
      <n-spin size="large" />
    </div>
    <RobotCheckModal :isRobot="isRobotCheck" />
  </div>

  <div class="content">
    <div style="display:block">
      <div class="breadCrumb_web">
        <n-breadcrumb separator=">">
          <n-breadcrumb-item @click="$router.push({path: `/helpcenter/${route.params.hashcode}`})">
            <n-icon size="20">
              <HomeOutline />
            </n-icon>
          </n-breadcrumb-item>
          <n-breadcrumb-item>View My Order</n-breadcrumb-item>
        </n-breadcrumb>
      </div>
      <div class="breadCrumb_mobile">
        <n-breadcrumb separator=">">
          <n-breadcrumb-item @click="$router.push({path: `/helpcenter/${route.params.hashcode}`})"><n-icon size="12"><HomeOutline /></n-icon></n-breadcrumb-item>
          <n-breadcrumb-item><span style="font-size: 11px">View My Order</span></n-breadcrumb-item>
        </n-breadcrumb>
      </div>
    </div>
    <div class="header_mix">
      <n-grid cols="1 700:2" class="order_details_mix">
        <n-grid-item>
          <div v-if="has3PlService">
            <h2 class="title_mobile">REF: {{refnumber}}</h2>
            <div class="title_web" v-if="Object.keys(realSalesOrder).length !== 0 && realSalesOrder?.status === 'fully_invoiced'">All items in your order have been packed.</div>
            <div class="title_web" v-if="Object.keys(realSalesOrder).length !== 0 && realSalesOrder?.status !== 'fully_invoiced'">There are items in your order have not been packed yet.</div>
            <div class="sub_title_mobile" v-if="Object.keys(realSalesOrder).length !== 0 && realSalesOrder?.status === 'fully_invoiced'"> All items in your order have been packed. <i style="color:red">*</i></div>
            <div class="sub_title_mobile" v-if="Object.keys(realSalesOrder).length !== 0 && realSalesOrder?.status !== 'fully_invoiced'"><b> There are items in your order have not been packed yet. </b><i style="color:red">*</i></div>
          </div>
          <div v-if="Object.keys(realSalesOrder).length !== 0 && !has3PlService" class="order_details">
            <n-space>
              <h2 class="title_mix">Salesorder: {{refnumber}} ({{ realSalesOrder.orderChannel }} Order) <span style="font-weight: 400;">{{realSalesOrder.timeCreated}}</span></h2>
            </n-space>
            <n-space>
              <div>{{realSalesOrder.customer}}; {{realSalesOrder.contact}}; {{realSalesOrder.email}}</div>
            </n-space>
            <n-space>
              <div v-if="realSalesOrder.address2">{{realSalesOrder.address1}}, {{realSalesOrder.address2}}, {{realSalesOrder.suburb}}, {{realSalesOrder.city}}, {{realSalesOrder.postcode}}</div>
              <div v-else>{{realSalesOrder.address1}}, {{realSalesOrder.suburb}}, {{realSalesOrder.city}}, {{realSalesOrder.postcode}}</div>
            </n-space>
          </div>
        </n-grid-item>
        <n-grid-item></n-grid-item>
        <n-grid-item>
          <div>
            <div class="sub_title_mix" v-if="realInvoiceOrder.length !== 0">
              <p class="create_date_mobile" v-if="Object.keys(realSalesOrder).length !== 0">{{ salesorderCreatedTime(realSalesOrder.timeinvoiced?.date)}}</p>
              Your order has {{ realInvoiceOrder.length }} shipment(s)
            </div>
          </div>
        </n-grid-item>
        <n-grid-item>
          <div>
            <p class="sub_title_web" v-if="Object.keys(realSalesOrder).length !== 0">{{ salesorderCreatedTime(realSalesOrder.timeinvoiced?.date)}}</p>
          </div>
        </n-grid-item>
      </n-grid>
    </div>
    <n-alert v-show="isErrorMsgShowing == true" :title="`Error: ${errorMsg}`" type="error">
      We are encountering a system issue, it will be repaired soon.
      Please try again later.  
    </n-alert>
    <n-alert v-show="isTrackingCodeInvalid" title="Error" type="error">
      Your tracking code was not found or has not been processed yet. Please double-check your code and try again.
    </n-alert>
    
    <div v-if="has3PlService">
      <div class="uninvoice_details" v-show="realUnInvoiceOrder.length !== 0">
      
        <h1 class="invoice_title">Items have not been packed</h1>
        <n-data-table :columns="uninvoiceColumns" :data="realUnInvoiceOrder[0]?.items.filter(res => !isNaN(parseInt(res.sku)))" class="table_web"/>
        <div class="list_mobile">
          <n-list bordered>
            <n-list-item v-for="item in realUnInvoiceOrder[0]?.items.filter(res => !isNaN(parseInt(res.sku)))" :key="item.sku">

              <n-grid x-gap="4" cols="6 s:4" responsive="screen">
                <n-grid-item>
                  <div style="text-align:center">
                    <a :href="item.product_url" v-if="item.img_url !== '#' && !item.img_url" target="_blank">
                      <img :src="item.img_url" class="invoiced_item_img"/>
                    </a>
                    <n-icon v-else size="70">
                      <Image />
                    </n-icon>
                  </div>
                </n-grid-item>
                <n-grid-item :offset="1" span="4 s:2">
                  <div>
                    <div class="item_info_mobile">
                      <a :href="item.product_url" target="_blank" style="color: #5B5B5B" v-if="item.product_url">{{item.desc.slice(0,31)}}</a>
                      <span v-else>{{item.desc.slice(0,31)}}</span>
                    </div>
                    <div style="margin-top:5px"><span class="item_info_mobile">{{item.sku}} &nbsp;&nbsp;&nbsp; X {{item.qty}}</span></div>
                      <p style="font-size:11px" v-if="item.stock_available_a !== 'NO STOCK' || item.stock_available_d !== 'NO STOCK' || item.stock_available_c !== 'NO STOCK'"><b>This item is usually dispatched within 1 day</b></p>
                      <n-grid cols="1">
                        <n-grid-item>
                        <div class="stock_space"><span class="warehouse_tag">AKL: </span> <n-tag :type="stockStatus(item.stock_available_a)" size="small">{{item.stock_available_a}} <span v-if="item.stock_available_a !== 'NO STOCK'">STOCK</span></n-tag></div>
                        </n-grid-item>
                        <n-grid-item>
                          <div class="stock_space"><span class="warehouse_tag">HAM: </span> <n-tag :type="stockStatus(item.stock_available_d)" size="small">{{item.stock_available_d}} <span v-if="item.stock_available_d !== 'NO STOCK'">STOCK</span></n-tag></div>
                        </n-grid-item>
                        <n-grid-item>
                          <div class="stock_space"><span class="warehouse_tag">CHC: </span> <n-tag :type="stockStatus(item.stock_available_c)" size="small">{{item.stock_available_c}} <span v-if="item.stock_available_c !== 'NO STOCK'">STOCK</span></n-tag></div>
                        </n-grid-item>
                        
                      </n-grid>
                  </div>
                </n-grid-item>
              <!--  <n-grid-item>
                  <div>
                    <n-button type="info" ghost style="width:100%; font-size:11px" @click="mobileCancelHandler(item)">Query</n-button>
                  </div>
                </n-grid-item> -->
              </n-grid> 
            </n-list-item>
          </n-list>
        </div>
        
      </div>
      <div class="invoiced_details" v-if="realInvoiceOrder.length !== 0">
        <hr v-if="realUnInvoiceOrder.length !== 0">
        <h1 class="invoice_title">Items have been packed</h1>
        <div class="invoice_sub_title" v-if="shouldSubTitleShow">
          <div>Our team members and delivery contractors are working hard to deliver your goods before this time.</div>
          <div>Please hold off on calling or emailing about your delivery until after {{realInvoiceOrder[0].delivery_eta_max_date}}</div>
        </div>
        
        <n-collapse default-expanded-names="2" accordion class="table_web">
          <n-collapse-item v-for="item in realInvoiceOrder" :title="item.refnumber" :name="item.refnumber" :key="item.refnumber">
            <div>
              <div class="invoices_status">
              <!--  <div v-html="item.trackingInfo[0]?.htmlContent"></div> -->
                <div v-if="(!item.hasOwnProperty('trackingInfo') || item.trackingInfo !== null) && item.ship_method !== 'PickUp'">
                  {{ numberOfItemsInOneInvoice(item.items) }} item(s) have been packed 
                  <span v-if="item.delivery_status == 'Completed'">
                    and sent to you {{ item.hasOwnProperty('trackingInfo') || item.trackingInfo == null? " " :daysOfItemLeaveWarehouse(item.trackingInfo[0]?.htmlContent)}} days ago from {{item.dispatch_warehouse}} warehouse
                  </span>
                </div>
                <div v-if="item.ship_method === 'PickUp'">{{ numberOfItemsInOneInvoice(item.items) }} item(s) are available in Trade Depot Now</div>
              </div>
              <!-- web invoiced -->
              <n-data-table :columns="invoicedColumns" :data="item.items.filter(res => !isNaN(parseInt(res.sku)) || res.sku === 'Sundry Credit')"/> 
            </div>

            <template #header>

              <div class="collapse_header">
                <div class="collapse_header_title">
                  <div class="title"> SHIPMENT</div> 
                  <div class="dateils"> {{item.refnumber}}</div>
                </div>

                <div class="collapse_header_title">
                  <div class="title">PACKED ON</div>
                  <div class="dateils">{{item.invoice_date.substr(0,10)}}</div>
                </div>

                <div class="collapse_header_title">
                  <div class="title">WAREHOUSE</div>
                  <div class="dateils">{{item.dispatch_warehouse.toUpperCase()}}</div>
                </div>

                <div class="collapse_header_title" v-if="item.delivery_latest_info">
                  <div class="title">LATEST DELIVERY STATUS</div> 
                  <div class="dateils">{{ item.delivery_latest_info}} </div>             
                </div>

                <div class="collapse_header_title" v-if="item.delivery_by === 'TD Truck' && item.delivery_status !== 'Completed'">
                  <div class="title">EXPECTED DELIVERY</div> 
                  <div  class="dateils" style="color: red">{{ item.delivery_eta_min_date}} - {{ item.delivery_eta_max_date }}</div>             
                </div>

              </div>
            </template>

            <template #header-extra>

              <div class="collapse_header_title" v-if="(!item.hasOwnProperty('trackingInfo') || item.trackingInfo !== null) && item.ship_method !== 'PickUp'">
                <div class="title">TRACKING NUMBER</div> 
                <a v-for="trackinfo in item.trackingInfo" :href="trackinfo.trackingUrl" class="dateils" target="_blank" title="link to Logistic" :key="trackinfo.trackingNumber">
                  {{ trackinfo.trackingNumber }}
                </a>
              </div>

              <div class="collapse_header_title" v-if="item.delivery_by !== ''">
                <div class="title">DELIVERY BY</div> 
                <div class="dateils">{{item.delivery_by}}</div>
              </div>

            </template>
          </n-collapse-item>
        </n-collapse>
        
        <!-- mobile invoiced -->
        <div class="list_mobile" v-for="invoice in realInvoiceOrder" :key="invoice.refnumber">
          <n-list bordered>
            <template #header>
            <div style="display:flex;">
              <div class="item_info_mobile" style="flex-grow:1;">
                <div><b>Shipment</b></div>
                <div>{{invoice.refnumber}}</div>
              </div> 
              <n-divider vertical v-if="invoice.delivery_by === 'TD Truck' && invoice.delivery_status !== 'Completed'" />
              <div v-if="invoice.delivery_by === 'TD Truck' && invoice.delivery_status !== 'Completed'" class="item_info_mobile" style="margin-right:5px">
                <div><b>Expected Delivery</b></div>
                <div style="color: red">{{ invoice.delivery_eta_min_date}} - {{ invoice.delivery_eta_max_date }}</div>
              </div> 
              <n-divider vertical v-if="invoice.delivery_by === 'TD Truck' && invoice.delivery_status !== 'Completed'" />
              <div class="item_info_mobile" style="margin-right:5px" v-if="invoice.delivery_by !== ''">
                <div><b>Delivery By</b></div>
                <div><a :href="deliveryUrl(invoice.delivery_by)" target="_blank" >{{invoice.delivery_by}}</a></div>
              </div>
              <n-divider vertical v-if="(!invoice.hasOwnProperty('trackingInfo') || invoice.trackingInfo !== null) && invoice.ship_method !== 'PickUp'" />
              <div class="item_info_mobile" v-if="(!invoice.hasOwnProperty('trackingInfo') || invoice.trackingInfo !== null) && invoice.ship_method !== 'PickUp'">
                <div><b>Tracking Number</b></div>
                <div>
                <n-space>
                  <a v-for="trackinfo in invoice.trackingInfo" :href="trackinfo.trackingUrl" :key="trackinfo.trackingInfo" target="_blank" title="link to Logistic">{{ trackinfo.trackingNumber }} </a>
                </n-space>
                </div>
              </div>
            </div>
              
            </template>
            <n-list-item v-if="invoice.delivery_latest_info">
              Latest Delivery Status <a :href="invoice.trackingInfo[0].trackingUrl" target="_blank" title="link to Logistic">(more details)</a><br/><b>{{invoice.delivery_latest_info}}</b>
            </n-list-item>
            <n-list-item v-for="item in invoice.items?.filter(res => (!isNaN(parseInt(res.sku)) || res.sku === 'Sundry Credit') && res.qty !== 0)" :key="item.sales_desc" >

              <n-grid x-gap="4" cols="6 s:4" responsive="screen">
                <n-grid-item>
                  <div style="text-align:center">
                    <a :href="item.product_url" v-if="item.img_url !== '#' && item.img_url" target="_blank">
                      <img :src="item.img_url" class="invoiced_item_img"/>
                    </a>
                    <n-icon v-else size="70">
                      <Image />
                    </n-icon>
                  </div>
                </n-grid-item>
                <n-grid-item :offset="1" span="4 s:2">
                  <div >
                    <div class="item_info_mobile">
                      <a :href="item.product_url" target="_blank" style="color: #5B5B5B" v-if="item.product_url">{{item.sales_desc.slice(0,31)}}</a>
                      <span v-else>{{item.sales_desc.slice(0,31)}}</span>
                    </div>
                    
                    <div style="font-size: 13px; padding-right:5px;margin-top:5px">
                    <!--  <span class="item_info_mobile" style="float:right">${{item.price.toFixed(2)}}</span> -->
                      <span class="item_info_mobile">{{item.sku}} &nbsp;&nbsp;&nbsp; X {{item.qty}}</span>
                    </div>
                    <p style="font-size:11px"><b>Dispatched for delivery {{item.invoiced_date.slice(0,10)}}</b></p>
                  </div>
                </n-grid-item>
              </n-grid> 
            </n-list-item>
          </n-list>
        </div>
      
      </div>
    </div>
    <div class="td_truck_table" v-else>
      <div class="test_details" v-show="tdTruckOrders.lines">
        <n-data-table :columns="tdTruckOrdersColumns" :data="tdTruckOrders.lines" :row-class-name="rowClassName" :scroll-x="900"/>
        <div v-show="!isPageLoading">
            <div><b>{{ tdTruckOrders.note1 }}</b></div>
            <div style="color: red"><b>{{ tdTruckOrders.note2 }}</b></div>
        </div>
      </div>
    </div>
    <!-- <div class="delivery_timetable_container" v-show="!isPageLoading">
        <table id="delivery_timetable">
          <thead>
            <tr>
              <th>AVERAGE DELIVERY TIMES*</th>
              <th>ALL ITEMS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Auckland City</td>
              <td>2-10 days</td>
            </tr>
            <tr>
              <td>Hamilton / Tauranga City</td>
              <td>2-10 days</td>
            </tr>
            <tr>
              <td>Wellington City</td>
              <td>2-14 days</td>
            </tr>
            <tr>
              <td>Rest of North Island</td>
              <td>2-14 days</td>
            </tr>
            <tr>
              <td>Christchurch City</td>
              <td>2-10 days</td>
            </tr>
            <tr>
              <td>Dunedin City</td>
              <td>2-14 days</td>
            </tr>
            <tr>
              <td>Rest of South Island</td>
              <td>2-14 days</td>
            </tr>
            <tr>
              <td><strong>Rural &amp; Remote Delivery Addresses</strong></td>
              <td colspan="2"><strong>ADD 5+ days</strong></td>
            </tr>
            <tr>
              <td><strong>Christmas period and public holiday weekends</strong></td>
              <td colspan="2"><strong>ADD 5+ days</strong></td>
            </tr>
            <tr>
              <td><strong>Weather or other events</strong></td>
              <td colspan="2"><strong>Expect delays</strong></td>
            </tr>
          </tbody>
        </table>
        <p>* Delivery timeframes begin once your payment has been validated, not from the time you placed the order. For higher-value orders, we may request identification to verify your purchase before processing.
          <br>We often deliver quicker, but please do expect delays, to be on the safe side.</p>
    </div> -->
    
    <div v-if="isInvoicedModalShow == true">
      <InvoiceModal :openInvoicedModal="isInvoicedModalShow" :salesorderDetails="realSalesOrder" :data="invoicedItemSelected" :status="invoicedItemStatus"  @close="invoicedModalToggleHandler"/>
    </div>
    <div v-if="isUninvoiceModalShow == true">
      <UninvoiceModal :openUninvoiceModal="isUninvoiceModalShow" :data="uninvoiceItemSelected" :orderDetails="realSalesOrder" @close="uninvoiceModalToggleHandler"/>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'
import { NBreadcrumb, NBreadcrumbItem, NCollapse,NCollapseItem, NDataTable, NTag, NGrid, NGridItem, NList, NListItem, NSpin, NDivider, NSpace, NIcon, NAlert, NText} from "naive-ui";
import {reactive, onMounted, ref, h, toRefs, computed} from "vue";
import axios from "axios";
import UninvoiceModal from "./uninvoice-modal/Uninvoice-Item-Modal"
import InvoiceModal from "./invoiced-modal/Invoiced-Item-Modal"
import { Image, HomeOutline } from '@vicons/ionicons5'
import {useReCaptcha} from "vue-recaptcha-v3"
import RobotCheckModal from "../../components/result/robotcheck/Robot-Check-Modal"
import dayjs from "dayjs";

const invoicedTableColumns = () =>{
  return[
    {
      title: "ITEM",
      key: "img",
      render(row){
        if(row.img_url === "#" || !row.img_url){
          return h("div", 
            {
              style:"text-align: left; cursor: pointer",
              onClick: () => {
                window.open(row.product_url)
              }
            },
            [
              // h(NIcon,{size:60},{
              //   default: () =>{
              //       return [
              //         h(Image)
              //       ]
              //   }
              // }),
              h("img", {src:`https://trade-depot.s3.ap-southeast-2.amazonaws.com/files/logo/broken_image_icon_150x150px.png`, style:"width:60px; height:60px; text-align:center", alt:`${row.sku}`}),
              h("div", row.sku)
            ]
          )
        }else{
          return h("div",
            {
              style:"text-align: left; cursor: pointer",
              onClick: () => {
                window.open(row.product_url)
              }
            },
            [
              h("img", {src:`${row.img_url}`, style:"width:60px; height:60px; text-align:center", alt:`${row.sku}`}),
              h("div", row.sku)
            ]
          )
        }
      },
       fixed: "left"
    },
    {
      title: "DESCRIPTION",
      key: "sales_desc"
    },
    {
      title: "QUANTITY",
      key: "qty",
      align: "right"
    },
  ]
} 

const uninvoiceTableColumns = ({vNodeTag}) =>{
  return [
  {
    title: "ITEM",
    key: "sku",
    render(row){
      if(row.img_url === "#" || !row.img_url){
        return h("div", 
          {
            style:"text-align: left; cursor: pointer", 
            onClick: () => {
              window.open(row.product_url)
            }
          },
          [
            // h(NIcon,{size:60},{
            //   default: () =>{
            //       return [
            //         h(Image)
            //       ]
            //   }
            // }),
            h("img", {src:`https://trade-depot.s3.ap-southeast-2.amazonaws.com/files/logo/broken_image_icon_150x150px.png`, style:"width:60px; height:60px; text-align:center", alt:`${row.sku}`}),
            h("div", row.sku)
          ]
        )
      }else{
        return h("div",
          {
            style:"text-align: left; cursor: pointer", 
            onClick: () => {
              window.open(row.product_url)
            }
          },
          [
            h("img", {src:`${row.img_url}`, style:"width:60px; height:60px; text-align:center", alt:`${row.sku}`}),
            h("div", row.sku)
          ]
        )
      }
    }
  },
  {
    title: "DESCRIPTION",
    key: "desc"
  },
  {
    title: "QUANTITY",
    key: "qty",
    align: "right",
    width: "100px"
  },
  {
    title: "AUCKLAND",
    key: "stock_available_a",
    width: "110px",
    render(row){
      return vNodeTag(row.stock_available_a)
    }
  },
  {
    title: "HAMILTON",
    key: "stock_available_d",
    width: "100px",
    render(row){
      return vNodeTag(row.stock_available_d)
    },
  },
  {
    title: "CHRISTCHURCH",
    key: "stock_available_c",
    width: "140px",
    render(row){
      return vNodeTag(row.stock_available_c)
    },
  },
  // { 
  //   title: "Action",
  //   key: "actions",
  //   render(row){
  //     return h(NButton, {type:"info", ghost:true, style:"width:100%; font-size:11px", onClick:()=> mobileCancelHandler(row)},{default: ()=> "Query"})
  //   }
  // }
  ]
} 

const tdTruckColumns = () => {
  return [
    {
      title: "SKU",
      key: "sku",
      align: "center",
      width: "80px",
      render(row){
        if(row.img === "#" || !row.img){
          return h("div",{style:"text-align: center"},[
              h("img", {src:`https://trade-depot.s3.ap-southeast-2.amazonaws.com/files/logo/broken_image_icon_150x150px.png`, style:"width:60px; height:60px; text-align:center", alt:`${row.sku}`}),
              h("div", `${row.sku}`)
          ])
        }else{
          return h("div",{style:"text-align: center"},
            [
              h("img", {src:`${row.img}`, style:"width:60px; height:60px; text-align:center", alt:`${row.sku}`, loading: "lazy"}),
              h("div", `${row.sku}`)
            ]
          )
        }
      }
    },
    {
      title: "DESC",
      key: "salesdesc",
      width: "130px",
      render(row){
        return h("div", {class: {description: true}}, row.salesdesc)
      }
    },
    {
      title: "ORD",
      key: "ord",
      align: "right",
      width: "40px"
    },
    {
      title: "INV",
      key: "inv",
      align: "right",
      width: "35px"
    },
    {
      title: "STATUS",
      key: "exdelivery",
      align: "left",
      width: "260px",
      render(row){
        const {uninvoiced = [], invoiced = [], doNotReorder} = row
        
        const uninvoicedOrders = uninvoiced.map(order => {
          const {warehouse = "", stockEtaText, eta, qty, type} = order

          if(type === "backorder"){
            let etaTime = ""
            if(stockEtaText) {
              const etaList = stockEtaText.split("ETA:")
              if(etaList.length > 1){
                let etaDateList = etaList[1].trim().split("/");
                etaTime = ` ETA to our warehouse. ${dayjs(`${etaDateList[2]}-${etaDateList[1]}-${etaDateList[0]}`).format("D MMM, ddd")}.`
              }
            }

            const backorderContent = h("div", {class: {"invoice-info": true}}, 
              [
                h("strong", `Preparing Your Order x${qty}`), 
                h("div", {}, `Goods on backorder.${etaTime}`)
              ]
            )

            if(etaTime){
              return backorderContent
            }else{
              if(doNotReorder && doNotReorder.toLowerCase() == "true"){
                return h("div", {class: {"invoice-info": true}}, 
                  [
                    h("strong", `Preparing Your Order x${qty}`), 
                    h("div", {}, [`There appears to be an error. Please `, h("a", {href: "https://tradedepot.co.nz/contact-us/", target: "_blank"}, "contact us"), " for assistance."])
                  ]
                )
              }else {
                return backorderContent
              }
            }
          }else if(type === "uninvoiced"){
            return h("div", {class: {"invoice-info": true}}, 
              [
                h("strong", `Awaiting Picking and Invoicing x${qty}`), 
                h("div", {}, [h("div", `Allocated to ${warehouse} Warehouse. In stock.`),h("div", `Normally picked within ${eta}.`)])
              ]
            )
          }
        })

        const invoicedOrders = invoiced.map((res, index) => {

          const {type, qty, refNumber} = res
          let result = []
          if(type === "invoiced"){
            const {isCrossIsland, island, invoicedDate_format} = res
            if(isCrossIsland == 1){
              result = [h("strong", {}, `Invoiced, but delivery not scheduled x${qty}`), h("div", {}, `INVOICE NO.${refNumber} Invoiced from ${island} Island. (${invoicedDate_format})`), h("div", {}, `Delivery Date TBC (ETA ${res.eta_format})`)]
            }else{
              result = [h("strong", {}, `Invoiced, but delivery not scheduled x${qty}`), h("div", {}, `INVOICE NO.${refNumber} (${invoicedDate_format})`), h("div", {}, `Delivery Date TBC (ETA ${res.eta_format})`)]
            }
          }else if(type === "delivered"){
            result = [h("strong", {}, `Delivered x${qty}`), h("div", {}, `INVOICE NO.${refNumber} delivered on ${res.date_format}`)]
          }else if(type === "pickup"){
            result = [h("strong", {}, `Collection x${qty}`), h("div", {}, `INVOICE NO.${refNumber}`)]
          }else if(type === "routeOptimised"){
            result = [
              h(NText, {type: "error"}, h("strong", {style: {fontSize: "16px"}}, `Estimated Delivery x${qty} ${res.eta_day_format}(${res.eta_format}) between ${res.eta_earliest_format} and ${res.eta_latest_format}. Traffic will affect actual delivery time.`))
            ]
          }else{
            result = [h("strong", {}, `Scheduled For Delivery x${qty}`), h("div", {}, `Invoiced ${res.invoicedDate_format} ${refNumber}`), h("div", {}, `Booked for truck departure on ${res.scheduledDate_format}`)]
          }
          return h("div", {key: index, class: {"invoice-info": true}}, result)
        })

        return h('div', {}, [...invoicedOrders, ...uninvoicedOrders])
      }
    },
  ]
}

export default {
  name: "Order",
  components:{
    NBreadcrumb,
    NBreadcrumbItem,
    NCollapse,
    NCollapseItem,
    NDataTable,
    // NButton,
    NGrid,
    NGridItem,
    NList,
    NListItem,
    UninvoiceModal,
    InvoiceModal,
    NSpin,
    NDivider,
    NSpace,
    NIcon,
    Image,
    HomeOutline,
    NTag,
    RobotCheckModal,
    NAlert
  },
  setup(){
    const route = useRoute()
    const { executeRecaptcha, recaptchaLoaded} = useReCaptcha();

    const isPageLoading = ref(true)
    const isRobotCheck = ref(false)

    const isInvoicedModalShow = ref(false)
    const isUninvoiceModalShow = ref(false)

    let state = reactive({
      refnumber: "",
      realSalesOrder:{},
      realInvoiceOrder:[],
      realUnInvoiceOrder:[],
      tdTruckOrders: {
        lines: []
      }
    })

    const invoicedItemSelected = ref({})
    const uninvoiceItemSelected = ref({})

    const invoicedItemStatus = ref(null)
    const isErrorMsgShowing = ref(false)
    const errorMsg = ref("")
    const isTrackingCodeInvalid = ref(false)

    const has3PlService = ref(null)

    const vNodeTag = (status) =>{
      if(status == "LOW") return h(NTag, {type: "error", size: "small"}, {default: ()=> status + " STOCK"}) 
      if(status === "MEDIUM") return h(NTag, {type: "warning", size: "small"}, {default: ()=> status + " STOCK"})
      if(status === "HIGH") return h(NTag, {type: "success", size: "small"}, {default: ()=> status + " STOCK"})
      if(status === "NO STOCK") return h(NTag, {style: { color: '#ccc', textColor: '#555', borderColor: '#555' }, size: "small"}, {default: ()=> status})
    }

    const deliveryUrl = (delivery) =>{
      if(delivery == "Castle Parcels") return "https://www.castleparcels.co.nz/contact_us.html"
      if(delivery == "Mainfreight") return "https://www.mainfreight.com/new-zealand/en-nz/contacts"
      if(delivery == "Fliway") return "https://www.fliway.com/contact-us.aspx"
      if(delivery == "TD Truck") return "#"
    }

    const numberOfItemsInOneInvoice = (array) =>{
      // console.log(array.filter(res => !isNaN(parseInt(res.sku))),"?")
      return array.filter(res => !isNaN(parseInt(res.sku))).reduce((previousValue, currentValue) => previousValue + currentValue.qty,0) 
    }

    const daysOfItemLeaveWarehouse = (html) =>{
      if(html?.length > 0 ){
        const shippingDate = `${html.slice(244,248)}-${html.slice(241,243)}-${html.slice(238,240)}`
      // console.log(Math.floor((new Date() - new Date(shippingDate))/(1000 * 60 * 60 * 24)))
        return Math.floor((new Date() - new Date(shippingDate))/(1000 * 60 * 60 * 24))
      }
      return
    }

    const salesorderCreatedTime = (time) => {
      const hours = new Date(time).getHours()
      const timePeriod = hours >= 12? "pm" : "am"
      return new Date(time).toUTCString().substr(4,18) + timePeriod
    }

    // const mobileCancelHandler = (item) =>{
    //   console.log(item,"testitem")
    //   isUninvoiceModalShow.value = true
    //   uninvoiceItemSelected.value = item
    // }

    const invoicedModalToggleHandler =() =>{
      isInvoicedModalShow.value = !isInvoicedModalShow.value
    }

    const uninvoiceModalToggleHandler =() =>{
      isUninvoiceModalShow.value = !isUninvoiceModalShow.value
    }

    //get order infomation from api
    const getData = async() =>{
      try{
        await recaptchaLoaded()
        const token = await executeRecaptcha("homepage");
        const params = new URLSearchParams();
        params.append('recaptchakey', token);
        isErrorMsgShowing.value = false

        const [recaptcha, dwData] = await axios.all([
          // TEMP: verification is best-effort — see the note above the score check below.
          axios.post(`https://help-api.tradedepot.co.nz/api/v1/recaptcha/signup`, params).catch(() => null),
          axios.get(`${process.env.VUE_APP_BUSINESS_CORE_URL}/Help/getFulfilmentInfoByHashCodeBeta?hashcode=${route.params.hashcode}`, {headers: {"X-API-KEY": process.env.VUE_APP_BUSINESS_CORE_API_KEY}})
        ])

        // TEMP (help-api outage): axios.all rejects if EITHER call fails, so an unreachable
        // reCAPTCHA verifier was blanking the whole order page. A returned score is STILL
        // enforced; only an unreachable verifier is allowed through. Enforcement resumes by
        // itself once help-api is healthy — no revert needed.
        const recaptchaScore = recaptcha && recaptcha.data ? recaptcha.data.score : undefined;
        if(recaptchaScore === undefined || recaptchaScore >= 0.5){

          const {code, data, is3PL} = dwData.data
          // console.log(dwData.data.data)

          if(code !== 200) return

          has3PlService.value = is3PL
          
          if(is3PL){
            if (data.salesorder.length === 0 && data.invoiced.length === 0 && data.un_invoiced.length === 0){
              isTrackingCodeInvalid.value = true
              return
            }

            state.realSalesOrder = data.salesorder
            state.realInvoiceOrder = data.invoiced.map(res =>{
              const refNumber = res.refnumber
              const invoiced_date = res.invoice_date
              res.items.map(item => {
                item.refnumber = refNumber
                item.invoiced_date = invoiced_date
                })
              return res
            })
            state.realUnInvoiceOrder = data.un_invoiced
            state.refnumber = data.salesorder.refnumber
          }else{
            // console.log(data.lines)
            if (data.lines.length === 0 && !data.refnumber){
              isTrackingCodeInvalid.value = true
              return
            }

            state.refnumber = data.refnumber
            state.tdTruckOrders = data
            data?.lines.map(item => {
              // console.log(item)
              item.invoiced.map(invoice => {
                const {type} = invoice
                // console.log(dayjs())
                if(type === "scheduled"){
                  invoice.invoicedDate_format = dayjs(invoice.invoicedDate).format("D MMM, ddd");
                  invoice.scheduledDate_format = dayjs(invoice.date).format("D MMM, ddd");
                  invoice.eta_format = dayjs(invoice.eta).format("D MMM, ddd");
                }else if(type === "delivered"){
                  invoice.date_format = dayjs(invoice.date).format("D MMM, ddd");
                }else if(type === "invoiced"){
                  invoice.eta_format = dayjs(invoice.eta).format("D MMM, ddd");
                  invoice.invoicedDate_format = dayjs(invoice.invDate).format("D/MM");
                }else if(type === "routeOptimised"){
                  invoice.eta_earliest_format = dayjs(invoice.eta).subtract(1, 'hour').format("h:mma");
                  invoice.eta_latest_format = dayjs(invoice.eta).add(1, 'hour').format("h:mma");
                  invoice.eta_format = dayjs(invoice.eta).format("D/MM");
                  invoice.eta_day_format = dayjs(invoice.eta).format("ddd");
                  
                }
                return invoice
              })
              return item
            })

            data.salesorder.timeCreated = dayjs(data.salesorder.timeCreated).format("ddd DD/MM HH:mm");
            state.realSalesOrder = data.salesorder
            // console.log(state.tdTruckOrders)
            // state.tdTruckOrders.lines = [
            //   {
            //     "salesdesc": "KLASSICH VANITY TOP CURVE GLOSS WHITE 800MM",
            //     "img": "https://s3-ap-southeast-2.amazonaws.com/fusionfactory.commerceconnect.etyit2u9.production/pim_media/000/036/479/214080-prod-01.jpg?1716870224",
            //     "qty": 5,
            //     "delivered": 1,
            //     "sku": "214080",
            //     "packed": 3,
            //     "invoices": [
            //         {
            //             "refnumber": "T6714317",
            //             "qty": 1,
            //             "etaDate": "",
            //             "completedDate": "31/08/2025",
            //             "type": "delivery"
            //         },
            //         {
            //             "refnumber": "T6714318",
            //             "qty": 1,
            //             "etaDate": "01/09/2025",
            //             "completedDate": "",
            //             "type": "delivery"
            //         },
            //         {
            //             "refnumber": "T6714319",
            //             "qty": 1,
            //             "etaDate": "",
            //             "completedDate": "",
            //             "type": "picked up"
            //         }
            //     ]
            //   },
            //   {
            //     "salesdesc": "Vogue Sombra Frameless Shower Door 1200mm Chrome",
            //     "img": "https://s3-ap-southeast-2.amazonaws.com/fusionfactory.commerceconnect.etyit2u9.production/pim_media/000/016/024/221527_Main_3000x3000.jpg?1684115665",
            //     "qty": 1,
            //     "delivered": 0,
            //     "sku": "221527",
            //     "packed": 1,
            //     "invoices" : [
            //         {
            //             "refnumber": "T6716067",
            //             "qty": 1,
            //             "etaDate": "01/09/2025",
            //             "completedDate": "",
            //             "type": "delivery"
            //         }
            //     ]
            //   },
            //   {
            //     "salesdesc": "P Pan to S Pan Connector",
            //     "img": "https://s3.ap-southeast-2.amazonaws.com/fusionfactory.commerceconnect.etyit2u9.production/channel_file/Image/67/239157-prod-1.jpg",
            //     "qty": 1,
            //     "delivered": 1,
            //     "sku": "239157",
            //     "packed": 1,
            //     "invoices": [
            //         {
            //             "refnumber": "T6714444",
            //             "qty": 1,
            //             "etaDate": "",
            //             "completedDate": "01/09/2025",
            //             "type": "delivery"
            //         }
            //     ]
            //   },
            //   {
            //     "salesdesc": "Master Kitchen Wall Oven 60cm 8 Function Knobs 72L",
            //     "invref": [
            //         ""
            //     ],
            //     "img": "https://s3-ap-southeast-2.amazonaws.com/fusionfactory.commerceconnect.etyit2u9.production/pim_media/000/062/591/310662-prod-01.jpg?1746489399",
            //     "exdelivery": "22nd August - 28th August",
            //     "qty": 1,
            //     "delivered": 1,
            //     "sku": "310662",
            //     "packed": 1,
            //     "invoices": [
            //         {
            //             "refnumber": "T6714451",
            //             "qty": 1,
            //             "etaDate": "",
            //             "completedDate": "",
            //             "type": "picked up"
            //         }
            //     ]
            //   },
            //   {
            //       "salesdesc": "Vogue Cascade Laundry Cabinet",
            //       "invref": [
            //           ""
            //       ],
            //       "img": "https://s3.ap-southeast-2.amazonaws.com/fusionfactory.commerceconnect.etyit2u9.production/channel_file/Image/67/575662-prod-1.jpg",
            //       "exdelivery": "22nd August - 28th August",
            //       "qty": 2,
            //       "delivered": 0,
            //       "sku": "575662",
            //       "packed": 0,
            //       "invoices": [
            //       ]
            //   }
            // ]
          }
        }else{
          isRobotCheck.value = true
        }
      }catch(err){
        isErrorMsgShowing.value = true
        errorMsg.value = `${err.response.status} ${err.response.statusText}`

        console.error(err.message)
      }finally{
        isPageLoading.value = false
      }
    }
    onMounted(() =>{
      getData()
    })

    const stockStatus = (stock) =>{
      if(stock == "HIGH") return "success"
      if(stock == "MEDIUM") return "warning"
      if(stock == "LOW") return "error"
      if(stock == "NO STOCK") return ""
    }

    const shouldSubTitleShow = computed(() => {
      const tdOrders = state.realInvoiceOrder.filter(order => order.ship_method === "TD Truck")
      if(tdOrders.length === 0) return false

      return tdOrders.every(order => order.delivery_status !== "Completed")
    })

    const rowClassName = (row) => {
      // console.log(row)
      if(row.uninvoiced) return ''

      if(row.invoiced.every(res => res.type === "delivered")){
        return "delivered-info"
      }

      return ''
    }

    return{
      route,
      isPageLoading,
      ...toRefs(state),
      numberOfItemsInOneInvoice,
      daysOfItemLeaveWarehouse,
      salesorderCreatedTime,
      invoicedColumns: invoicedTableColumns({
      }),
      uninvoiceColumns: uninvoiceTableColumns({
        // mobileCancelHandler, 
        vNodeTag
      }),
      // mobileCancelHandler,
      isUninvoiceModalShow,
      invoicedModalToggleHandler,
      invoicedItemSelected,
      isInvoicedModalShow,
      uninvoiceItemSelected,
      uninvoiceModalToggleHandler,
      invoicedItemStatus,
      stockStatus,
      deliveryUrl,
      isRobotCheck,
      isErrorMsgShowing,
      errorMsg,
      isTrackingCodeInvalid,
      shouldSubTitleShow,
      has3PlService,

      tdTruckOrdersColumns: tdTruckColumns({}),
      rowClassName
    }
  }

}
</script>

<style scoped>
  .content{
    padding-top: 20px
  }
  .loading{
    width:100%;
    height:100%;
    position: absolute;
    left:0;
    background-color: rgba(0,0,0,0.65);
    z-index:100
  }

  h2{
    margin:0
  }
  p{
    margin: 0;
  }
  .sub-header{
    /*width:180px;*/
    margin-right: 20px;
  }
  .n-gradient-text{
    font-size: 1.5em;
  }

  .title_web{
    font-weight: bold;
    font-size: 17px
  }

  .breadCrumb_mobile{
    display:none
  }

  .title_mobile{
    display:none;
  }

  .invoiced_details{
    margin-top: 20px;
  }

  .collapse_header{
    display: flex;
  }

  .collapse_header_title{
    padding: 0 10px;
    font-weight: 600;
    font-size:18px
  }

  .collapse_header_title:not(:last-child){
    border-right: 1px solid grey;
  }

  .collapse_header_title > div{
    /*padding: 0 10px;*/
    font-weight: bold;
  }

  .collapse_header_title > .title{
    font-size:14px
  }

  .collapse_header_title > .dateils{
    font-size:14px
  }

  .invoices_status{
    font-size:16px
  }

  .order_details_mix{
    margin: 25px 0;
  }

  .order_details_mix > div {
    width: 100%;
  }

  .sub_title_web{
    font-size: 14px;
    visibility: hidden;
  }

  .create_date_mobile{
    display:none
  }

  .sub_title_mobile{
    display:none
  }

  .list_mobile{
    display:none
  }

  .order_details_mix > div:nth-child(even){
    text-align: right;
  }

  .order_details_mix > div:nth-child(3){
  }

  .delivery_success{
    color: #42b983;
    border: 1px solid black;
    border-radius: 80%;
  }

  .uninvoice_details{
    margin-top: 30px;
  }

  .invoiced_item_img{
    width:85px;
  }

  .warehouse_tag{
    display: inline-block;
    width:40px
  }

  .delivery_timetable_container{
    padding: 0 30%;
  }

  #delivery_timetable{
    margin-top: 20px;
    border: solid 1px #e5e5e5;
    margin-bottom: 2rem;
    table-layout: auto;
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
  }

  #delivery_timetable thead{
    background: #e5e5e5;
    text-align: left;
  }

  .invoice_sub_title{
    font-weight: bold;
    margin-bottom: 10px;
  }
  
  .invoice_sub_title > div:nth-of-type(2){
    color: red;
  }

  .td_truck_table{
    width: 70%; 
    margin: auto;
  }

  :deep(.invoice-info:not(:last-child)){
    padding-bottom: 5px;
    border-bottom: 1px solid transparent;
    background: linear-gradient(to right, #ccc 0%, #ccc 90%, transparent 90%, transparent 100%) bottom
    / 100% 1px no-repeat;
    margin-bottom: 5px;
  }

  :deep(.delivered-info td){
    background: #FAFAFA;
  }

  :deep(.description){
    overflow: hidden;
    text-overflow:ellipsis;
    display: -webkit-box;
    word-break: break-all;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .order_details{
    margin-left: 10%;
  }
@media only screen and (max-width: 1512px) {
  .td_truck_table{
    width: 75%; 
    margin: auto;
  }

  .order_details{
    margin-left: 0;
  }
}

@media only screen and (max-width: 1024px) {
  .td_truck_table{
    width: 100%; 
    margin: auto;
  }

  .title_mix{
    font-size:15px
  }
  .title_web{
    font-weight: bold;
    font-size: 14px
  }

  .invoice_title{
    font-size:1.4em
  }

  .collapse_header_title:nth-of-type(3){
    display: none;
  }

  .collapse_header_title > div{
    /*padding: 0 10px;*/
    font-weight: bold;
    font-size:14px
  }

  .collapse_header_title > .title{
    font-size:13px
  }

  .delivery_timetable_container{
    padding: 0 25%;
  }
}

@media only screen and (max-width: 768px) {

  /* .td_truck_table{
    width: 100%; 
    margin: auto;
  } */
  
  .title_mix{
    display:inline;
    font-size: 15px;
    margin:0;
    float:right
  }

  .breadCrumb_web{
    display:none
  }

  .breadCrumb_mobile{
    display:block
  }

  .sub_title_mix{
    line-height:1.1
  }

  .title_web{
    display:none
  }

  .sub_title_web{
    display:none
  }
  
  .title_mobile{
    display:inline;
    font-size: 15px;
    float:right
  }

  .order_details_mix > div:nth-child(3){
      font-size: 11px;
    }
  .create_date_mobile{
    display:block;
    font-size: 12px;
    float:right
  }

  .sub_title_mobile{
    display:block;
    font-size: 11px;
  }

  .header_mix{  
  }

  .list_mobile{
    display:block
  }

  .order_details_mix > div:nth-child(2) {
    display:none
  }

  .order_details_mix > div:nth-child(even) {
    text-align:left
  }

  /* .invoice_title{
    font-size:13px
  } */

  .table_web{
    display:none
  }
  
  .item_info_mobile{
    font-size:11px;
  }

  .stock_space{
    margin-top:7px
  }

}
@media only screen and (max-width: 450px) {
  /* .td_truck_table{
    width: 100%; 
    margin: auto;
  } */

  .sub_title_mobile{
    max-width:250px;
    line-height:1.2;
    font-size:14px;
    margin-bottom:5px
  }
  .create_date_mobile{
    font-size:11px;
    visibility: hidden;
  }

  .delivery_timetable_container{
    padding: 0 5%;
  }
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 100;
}

.loading-content {
  text-align: center;
}

</style>